module.exports = __webpack_public_path__ + "media/images/builder/style-502b62034f39dbdcacc012800e651b09.jpg";